import React from "react";

import Layout from "../components/nosotrosLayout";

const Page = () => <Layout />;

export default Page;
